import authAxios from "./api";
import TokenService from "./token.service";

const USERS_REST_API_URL = "http://85.159.27.198:8080/abitur/api/v1";

export class StreamService {
  static getStreams(teacherId) {
    return authAxios.get(`${USERS_REST_API_URL}/teacher/${teacherId}/streams`);
  }

  static getLessons(teacherId, streamId) {
    return authAxios.get(
      `${USERS_REST_API_URL}/teacher/${teacherId}/streams/${streamId}/lessons?sortbydate=true`
    );
  }

  static getAssessmentsOfEachStudent(teacherId, streamId) {
    return authAxios.get(
      `${USERS_REST_API_URL}/teacher/${teacherId}/streams/${streamId}/students/assessments`
    );
  }
  static getFinalAssessments(streamId) {
    return authAxios.get(
      `${USERS_REST_API_URL}/final-assessment/get-by-streamid/${streamId}`
    );
  }

  static createFinalAssessments(studentGrades) {
    return authAxios.post(
      `${USERS_REST_API_URL}/final-assessment/create`,
      studentGrades
    );
  }

  static updateAssessmentsOfEachStudent(teacherId, studentGrades) {
    return authAxios.post(
      `${USERS_REST_API_URL}/teacher/${teacherId}/lessons/assessment`,
      studentGrades
    );
  }

  static deleteAssessmentsOfEachStudent(teacherId, deletedGrades) {
    return authAxios.delete(
      `${USERS_REST_API_URL}/teacher/${teacherId}/lessons/assessment`,
      {
        data: deletedGrades,
      }
    );
  }
}
